import { defineStore, acceptHMRUpdate } from "pinia";
import { brogglBack } from "../axios.js";
import router from "../router/index.js";
import { useClientStore } from "./client.js";
import { useFormStore } from "./form.js";
import { useUserStore } from "./user.js";
import { useEntriesStore } from "./entries.js";
import { newProjects2 } from "../assets/variables.js";
import dayjs from "dayjs";

export const useProductStore = defineStore("product", {
  state: () => ({
    products: [],
    oldProduct: null,
    campaignsForProduct: [],
    productListKey: 0,
  }),
  getters: {
    getProducts: (state) => {
      return state.products;
    },
    getOldProduct: (state) => {
      return state.oldProduct;
    },
    getIsClientProductsLoaded: (state) => {
      return state.isClientProductsLoaded;
    },
    getProductListKey: (state) => {
      return state.productListKey;
    },
    getCampainsProduct: (state) => {
      return state.campaignsForProduct;
    },
  },
  actions: {
    async fetchProducts() {
      this.isClientProductsLoaded = false;
      const clientStore = useClientStore();
      const formStore = useFormStore();
      let clientId = clientStore.getClientId();
      let currContractId = clientStore.currContractId;
      let client = null;
      if (clientStore.client === null) {
        client = await clientStore.forceToFetchClient(
          router.currentRoute.value.params.id,
        );
      } else {
        client = clientStore.client;
      }
      let itemToAppendToProducts = [
        // {
        //   ProductName: 'No package',
        //   ID: -1
        // },
        {
          ProductName: "Duplicate",
          ID: -2,
        },
      ];
      try {
        this.products = [];
        const res = await brogglBack.get("/product/products/" + clientId, {
          params: { oppId: currContractId },
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
        });
        if (res.data != null) {
          res.data.data.forEach((product) => {
            this.products = [...this.products, product];
          });
          itemToAppendToProducts.forEach((product) => {
            this.products = [...this.products, product];
          });
          formStore.parameters.productId = -1;
          this.isClientProductsLoaded = true;
          this.productListKey += 1;
        } else if (res.status === 401) {
          window.$cookies.set("jwt", "");
        }
        this.products.forEach(async (product) => {
          if (product.ID > 0) {
            let campaigns = [];
            let res = {};
            if (clientStore.currContractId > 0) {
              res = await brogglBack.get(
                "/test/test-for-product/" + product.ID,
                {
                  params: { contractId: clientStore.currContractId },
                  headers: {
                    Authorization: "Bearer " + window.$cookies.get("jwt"),
                  },
                },
              );
            } else {
              res = await brogglBack.get(
                "/test/test-for-product/" + product.ID,
                {
                  headers: {
                    Authorization: "Bearer " + window.$cookies.get("jwt"),
                  },
                },
              );
            }
            if (res.data != null) {
              campaigns = res.data.data;
            }
            this.campaignsForProduct[product.ID] = campaigns;
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async fetchProductList(clientId, oppId) {
      let result = [];
      let itemToAppendToProducts = [
        // {
        //   ProductName: 'No package',
        //   ID: -1
        // },
        {
          ProductName: "Duplicate",
          ID: -2,
        },
      ];
      try {
        const res = await brogglBack.get("/product/products/" + clientId, {
          params: { oppId: currContractId },
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
        });
        if (res.data != null) {
          res.data.data.forEach((product) => {
            result = [...result, product];
          });
          itemToAppendToProducts.forEach((product) => {
            result = [...result, product];
          });
          this.parameters.productId = -1;
        } else if (res.status === 401) {
          window.$cookies.set("jwt", "");
        }
      } catch (err) {
        console.log(err);
      }
    },
    async fetchProduct(productId) {
      try {
        const res = await brogglBack.get("/product", {
          params: { id: productId },
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
        });
        if (res.data != null) {
          this.products.push(res.data.data);
        } else if (res.status === 401) {
          window.$cookies.set("jwt", "");
        }
      } catch (err) {
        console.log(err);
      }
    },
    checkIfProductExist(productId) {
      let result = false;
      this.products.forEach((product) => {
        if (product.ID === productId) {
          result = true;
        }
      });
      return result;
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useProductStore, import.meta.hot));
}
